import React from 'react';
import { connect } from 'react-redux';
import {
  Row,
  Col,
} from 'reactstrap';
import FontSelect from '../../FontSelect';
import ColorPicker from '../../ColorPicker';

class Styling extends React.PureComponent {
  render() {
    return (
      <Row className="px-5 py-3 fade-in">
        <Col>
          <ColorPicker id="bgColor">Background Color</ColorPicker>
          <ColorPicker id="buttonColor">Button Color</ColorPicker>
          <ColorPicker id="pageHeaderColor">Page Header Color</ColorPicker>
          <ColorPicker id="linkColor">Text Link Color</ColorPicker>
          <ColorPicker id="textColor">Text Color</ColorPicker>
          <FontSelect id="fontStyle">Font Style</FontSelect>
        </Col>
        <Col />
        <Col />
      </Row>
    );
  }
}

export default connect()(Styling);
